import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader, getUserParam } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import { DataTransferCreate } from "../../reducer/types";
import { BRANCH_OTHER } from "../../transfer-utils/transfer.utils";
import {
  FetchTransferForeignAccountDetailRequest,
  FetchTransferForeignAuthorizationRequest,
  FetchTransferForeignConfirmRequest,
} from "../reducer/types";
import { Constant } from "app/shared/constant/constant";

const accountDetailParam = (action: FetchTransferForeignAccountDetailRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      FEE_TYPE: action.payload.FEE_TYPE,
      SERVICE_CODE: ServiceCode.TRANSFER_247,
      CREDIT_ACCOUNT_NUMBER: action.payload?.ACCOUNT_CREDIT?.ACCOUNTNO,
      CREDIT_ACCOUNT_TYPE: action.payload?.ACCOUNT_CREDIT?.ACCOUNTTYPE,
      CREDIT_BANK_CODE: action.payload?.BANK?.value || "",
      CREDIT_BANK_NAME: action.payload?.BANK?.label || "",
      DEBIT_ACCOUNT_NUMBER: action.payload.ACCOUNT_DEBIT?.ACCOUNTNO,
      DEBIT_ACCOUNT_TYPE: action.payload.ACCOUNT_DEBIT?.ACCOUNTTYPE,
      TRANSACTION_DESCRIPTION: action.payload.DESCRIPTION,
      TRANSACTION_AMOUNT: action.payload.AMOUNT,
      TRANSACTION_POSTING: "UPDATE",
      TYPE: action.payload.TYPE || Constant.TRANSFER.TRANSFER_247_TYPE.ACC,
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

const createParam = (dataCreate: DataTransferCreate): REQUESTINPUT => {
  let branchCode = dataCreate.BRANCH?.value || "";
  let branchName = dataCreate.BRANCH?.label || "";
  if (dataCreate.BRANCH?.value === BRANCH_OTHER) {
    branchCode = dataCreate.BANK?.value || "";
    branchName = dataCreate.BRANCH?.other || "";
  }
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      FEE_TYPE: dataCreate.FEE_TYPE,
      SERVICE_CODE: ServiceCode.TRANSFER_FOREIGN,
      CREDIT_ACCOUNT_NUMBER: dataCreate.ACCOUNT_CREDIT?.ACCOUNTNO,
      CREDIT_ACCOUNT_NAME: dataCreate.ACCOUNT_CREDIT?.ACCOUNTNAME,
      CREDIT_ACCOUNT_TYPE: dataCreate.ACCOUNT_CREDIT?.ACCOUNTTYPE,
      CREDIT_BANK_CODE: dataCreate.BANK?.value || "",
      CREDIT_BANK_NAME: dataCreate.BANK?.label || "",
      CREDIT_BANK_AREA: dataCreate.AREA?.value || "",
      CREDIT_BRANCH_CODE: branchCode,
      CREDIT_BRANCH_NAME: branchName,
      CREDIT_BANK_CITAD_CODE: "BRANCH" + branchCode,
      DEBIT_ACCOUNT_NUMBER: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
      DEBIT_ACCOUNT_TYPE: dataCreate.ACCOUNT_DEBIT?.ACCOUNTTYPE,
      TRANSACTION_AMOUNT: dataCreate.AMOUNT,
      TRANSACTION_DESCRIPTION: dataCreate.DESCRIPTION,
      TRANSACTION_POSTING: "UPDATE",
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

const confirmParam = (action: FetchTransferForeignConfirmRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      ...action.payload?.TRANSFER,
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

const authParam = (action: FetchTransferForeignAuthorizationRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    AUTHORIZE_CODE: action.code,
    CHALLENGE_ID: action.payload?.CHALLENGE_ID,
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      RQSTSEQ: action.payload?.TRANSFER?.RQSTSEQ || "",
      TRANSACTION_POSTING: action.payload?.TRANSFER?.TRANSACTION_POSTING || "UPDATE",
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

export const fetchTransferForeignCreateService = async (dataCreate: DataTransferCreate) => {
  const params: REQUESTINPUT = createParam(dataCreate);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_CIF_TRANSFER);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

// Xác nhận chuyển tiền
export const fetchTransferForeignConfirmService = async (actionRq: FetchTransferForeignConfirmRequest) => {
  const params: REQUESTINPUT = confirmParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_CHECK_TRANSFER_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTransferForeignAuthService = async (actionRq: FetchTransferForeignAuthorizationRequest) => {
  const params: REQUESTINPUT = authParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_AUTHORIZE_TRANSFER);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

/** Lấy thông tin chi tiết tk nhận */
export const fetchTransferForeignAccountDetailService = async (actionRq: FetchTransferForeignAccountDetailRequest) => {
  const params: REQUESTINPUT = accountDetailParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_CIF_TRANSFER_DIRECT);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
